// index.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'

import { externalNewsletterDispatchers as dispatchers } from 'reduxModules/users/dispatchers'
import { externalNewsletterReselector as stateSelector } from 'reduxModules/users/selectors'

import '../../generic/RenderedField/styles.css'
import './styles.css'

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export function ExternalEmailFunnelDialog({
  isPopUp = false,
  onSubmit,
  tag
}) {
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid }
  } = useForm({ mode: 'onChange' })

  return (
    <section id="ExternalEmailFunnelDialog" className={isPopUp ? 'popup' : ''}>
      <div className="internal-container wrapper">
        <div className="copy">
          <h2 className="title">Enjoying our courses?</h2>
          <div className="subtitle">
            <p className="tagline">
              Join our Newsletter for updates about new courses, artists, and
              student contests!
            </p>
          </div>
        </div>

        <div className="form">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={classnames('field', '-floating', { '-error': errors.email })}>
              <div className="field-container">
                <input
                  {...register('email', {
                    required: 'This field is required.',
                    pattern: {
                      value: EMAIL_PATTERN,
                      message: 'Invalid email address.'
                    }
                  })}
                  type="email"
                  placeholder=" "
                  id={`${tag}-email-field`}
                  key={`${tag}-email-field`}
                />
                <label htmlFor={`${tag}-email-field`}>Email</label>
                <span
                  className={`field__error${!errors.email ? ' field__error--hidden' : ''}`}
                  role="alert"
                >
                  {errors.email?.message}
                </span>
              </div>
            </div>

            <button
              type="submit"
              className="btn -wide -blue-2"
              disabled={!isDirty || !isValid}
              aria-label="Enter your email and click submit to receive your free content"
            >
              Sign Me Up
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

ExternalEmailFunnelDialog.propTypes = {
  tag: PropTypes.string.isRequired,
  isPopUp: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
}

export default connect(stateSelector, dispatchers)(ExternalEmailFunnelDialog)
